export default {
  russia: 7,
  kazakhstan: 1,
};
